<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="450"
    :fullscreen="this.$vuetify.breakpoint.xsOnly"
    persistent
  >
    <v-card :tile="this.$vuetify.breakpoint.xsOnly" class="white black--text">
      <v-toolbar light flat tile class="flex-grow-0">
        <v-btn icon v-on:click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-black title">
          Nº {{ bet.id }}
          <span
            class="font-weight-black"
            v-html="$infoTable.statusBet(bet.status_bet)"
          ></span>
          <div class="caption">{{ bet.date | dateFormat }} {{ $gmt() }}</div>
        </v-toolbar-title>
      </v-toolbar>

      <v-divider light></v-divider>
      <v-card-text class="pt-2 px-4 white black--text">
        <p class="text-center font-weight-bold" v-show="bet.status_bet != '1'">
          {{ $t("BETCONFERENCE") }}
          <br />
          {{ $t("NOVALIDFORAWARD") }}
        </p>
        <div class="py-0">
          <div
            v-for="(event, index) in bet.events"
            :key="event[0]"
            class="d-flex flex-column"
          >
            <v-divider light v-show="index" class="ml-8 pb-2"></v-divider>
            <div class="d-flex pb-2">
              <div class="pr-4 d-flex justify-center">
                <v-icon light>mdi-circle-medium</v-icon>
              </div>
              <div class="flex-grow-1 d-flex flex-column text-truncate mr-2">
                <div class="overline text-truncate">
                  {{ event.category_name }} - {{ event.tournaments_name }}
                </div>
                <div class="d-flex justify-space-between">
                  <div class="subtitle-2 text-truncate">
                    <div class="d-flex align-center my-1">
                      <TeamLogo
                        :id_sport="event.id_sport"
                        :id_team="event.id_team_1"
                        :type_size="'medium_logo'"
                        :size="'24px'"
                        class="mr-1"
                      />
                      {{ event.description.split(" X ")[0] }}
                    </div>
                    <div class="d-flex align-center my-1">
                      <TeamLogo
                        :id_sport="event.id_sport"
                        :id_team="event.id_team_2"
                        :type_size="'medium_logo'"
                        :size="'24px'"
                        class="mr-1"
                      />
                      {{ event.description.split(" X ")[1] }}
                    </div>
                  </div>
                  <div class="d-flex flex-column justify-center align-end">
                    <!-- Statscore -->
                    <div v-if="$permissions().statsCore">
                      <v-btn
                        light
                        fab
                        elevation="0"
                        @click="openTracker(bet.id, event.id_event)"
                      >
                        <v-icon
                          :color="
                            idEvent == event.id_event && idBet == bet.id
                              ? 'primary'
                              : ''
                          "
                          >mdi-soccer-field</v-icon
                        >
                      </v-btn>
                    </div>
                    <!-- / Statscore -->
                  </div>
                </div>

                <div class="caption">
                  {{ event.scheduled | dateFormat }} {{ $gmt() }}
                </div>
                <!-- Statscore -->
                <div v-show="!disabledWidget && idEvent == event.id_event">
                  <div style="background: rgba(0, 0, 0, 0.2)">
                    <div
                      style="max-width: 450px; margin: 0 auto"
                      :id="`widget-${bet.id}-${event.id_event}`"
                    ></div>
                  </div>
                </div>
                <div
                  v-if="
                    idEvent == event.id_event && idBet == bet.id && unavailable
                  "
                  class="pa-4 text-center caption mb-1"
                  style="
                    background-color: rgba(0, 0, 0, 0.2);
                    border-radius: 4px;
                  "
                >
                  {{ $t("unavailableTracker") }} 😞
                </div>
                <!-- / Statscore -->
                <div
                  class="text-truncate d-flex flex-column pa-1"
                  style="
                    border: 1px solid #cccccc;
                    border-radius: 8px;
                    width: 100%;
                  "
                >
                  <div class="d-flex justify-space-between">
                    <div class="font-weight-black">
                      {{ nameOdds(event.id_outcome) }}
                    </div>
                    <div class="font-weight-black text-right">
                      {{ event.factor_event }}
                    </div>
                  </div>
                  <div class="d-flex justify-space-between">
                    <div>
                      {{ nameMarkets(event.id_market) }}
                    </div>
                    <div class="text-right">
                      <div
                        class="font-weight-black"
                        v-html="
                          conference(event.result_event, event.status_event)
                        "
                      ></div>
                      <v-chip
                        v-if="event.live_event === '1'"
                        class="font-weight-black"
                        color="info"
                        small
                      >
                        {{ $t("live") }}
                      </v-chip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>

      <v-divider light></v-divider>

      <v-card-actions>
        <div class="py-2 px-2 d-flex flex-grow-1 flex-column body-2">
          <div
            v-if="!bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("allOdds") }}</div>
            <div class="font-weight-black">{{ bet.factor_bet }}</div>
          </div>
          <div
            v-if="!bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("value") }}</div>
            <div class="font-weight-black">{{ bet.amount }}</div>
          </div>
          <div
            v-if="!bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("possibleReturn") }}</div>
            <div v-if="bet.result_bet == 2">
              <span class="text-decoration-line-through grey--text">{{
                getPreviousBetValue(bet.amount, bet.factor_bet)
              }}</span
              >&nbsp;
              <span class="font-weight-black">{{ bet.prize }}</span>
            </div>
            <div v-else class="font-weight-black">
              {{ bet.prize }}
            </div>
          </div>
          <div
            v-if="!bet.action && agentPercentage && agentPercentage > 0"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("clientGains") }}</div>
            <div class="font-weight-black">
              {{ (bet.prize - bet.prize * agentPercentage).toFixed(2) }}
            </div>
          </div>
          <div
            v-if="bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("action") }}</div>
            <div class="font-weight-black">{{ bet.action }}</div>
          </div>
          <div
            v-if="bet.action"
            class="d-flex justify-space-between align-center"
          >
            <div>{{ $t("reverseAmount") }}</div>
            <div class="font-weight-black">{{ bet.factor * bet.amount }}</div>
          </div>
          <div class="d-flex justify-space-between align-center">
            <div>{{ $t("conference") }}</div>
            <div
              class="font-weight-black"
              v-html="conference(bet.result_bet, bet.status_bet, bet.reason)"
            ></div>
          </div>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
.bet-aut {
  word-wrap: break-word !important;
}
</style>

<script>
// import QrcodeVue from "qrcode.vue";
// import Vue from "vue";
var widget = "";
import TeamLogo from "@/components/team-logo";
export default {
  name: "dialog-consult-bet",
  props: ["data"],

  components: {
    // QrcodeVue,
    TeamLogo,
  },
  data: () => {
    return {
      bet: "",
      dialog: false,
      valueQrcode: "",
      sizeQrcode: 100,
      agent: "",
      // Statscore:
      disabledWidget: false,
      idBet: "",
      idEvent: "",
      unavailable: false,
    };
  },
  async beforeDestroy() {
    if (this.$permissions().statsCore) {
      if (widget != "") {
        await widget.destroy();
      }
    }
  },
  watch: {
    data: {
      handler: function(val) {
        this.agent = val.agent;
        this.bet = val.dados.apostas[0];
        this.dialog = true;
      },
      deep: true,
    },
  },

  computed: {
    maxPrize() {
      return this.$store.state.operators.max_prize;
    },
    agentPercentage() {
      if (
        this.agent &&
        this.$store.state.operators &&
        this.$store.state.operators.retail == 1
      ) {
        const { percentage_prize, events_prize } = this.agent;

        if (percentage_prize && events_prize) {
          if (percentage_prize > 0) {
            const bet_data = this.bet;

            if (bet_data && bet_data.events.length >= events_prize) {
              return percentage_prize / 100;
            } else {
              return 0;
            }
          } else {
            return 0;
          }
        }
      }
      return 0;
    },
  },
  methods: {
    decimalAdjustment: function(num) {
      return -(Math.round(-num + "e+2") + "e-2");
    },
    getPreviousBetValue(amount, odd) {
      const prize = amount * odd;

      if (prize > this.maxPrize) {
        return this.decimalAdjustment(this.maxPrize);
      }

      return this.decimalAdjustment(prize);
    },
    nameMarkets(id_market) {
      const markets = this.$store.getters.getMarkets;
      for (let m of markets) {
        if (m.id_market == id_market) {
          return m.name_market;
        }
      }
    },

    nameOdds(id_outcome) {
      const odds = this.$store.getters.getResults;
      for (let o of odds) {
        if (o.id_outcome == id_outcome) {
          return o.name_outcome;
        }
      }
    },

    msgReasion: function(r) {
      const msg_reasion = {
        0: "OTHER",
        1: "NO_GOALSCORER",
        2: "CORRECT_SCORE_MISSING",
        3: "RESULT_UNVERIFIABLE",
        4: "FORMAT_CHANGE",
        5: "CANCELLED_EVENT",
        6: "MISSING_GOALSCORER",
        7: "MATCH_ENDED_IN_WALKOVER",
        8: "DEAD_HEAT",
        9: "RETIRED_OR_DEFAULTED",
        10: "EVENT_ABANDONED",
        11: "EVENT_POSTPONED",
        12: "INCORRECT_ODDS",
        13: "INCORRECT_STATISTICS",
        14: "NO_RESULT_ASSIGNABLE",
        15: "CLIENT_SIDE_SETTLEMENT_NEEDED",
        16: "STARTING_PITCHER_CHANGED",
      };

      return msg_reasion[r];
    },

    conference: function(result_bet, status_bet, reason) {
      if (result_bet == 2) {
        return `<span class="my-1 v-chip theme--light v-size--small lime darken-2 white--text"><span class="v-chip__content text">${this.$t(
          "finished"
        )}</span></span>`;
      }

      if (status_bet == 0) {
        return `<span class="my-1 v-chip theme--light v-size--small purple darken-3 white--text"><span class="v-chip__content text">${this.$t(
          "cancel"
        )}</span></span>`;
      } else {
        if (result_bet == 1) {
          return `<span class="my-1 v-chip theme--light v-size--small green darken-3 white--text"><span class="v-chip__content">${this.$t(
            "right"
          )} </span></span>`;
        } else if (result_bet == 0 && result_bet != "") {
          if (reason) {
            return `<span class="orange--text">${this.$t(
              "reimbursement"
            )}</span><strong class="orange--text"> (${this.msgReasion(
              reason
            )})</strong>`;
          } else {
            return `<span class="my-1 v-chip theme--light v-size--small red darken-3 white--text"><span class="v-chip__content">${this.$t(
              "missed"
            )}</span></span>`;
          }
        } else {
          return `<span class="my-1 v-chip theme--light v-size--small grey darken-3 white--text"><span class="v-chip__content">${this.$t(
            "pendentStatus"
          )}</span></span>`;
        }
      }
    },

    // Open Live Match Pro (Statscore)
    openTracker(id_bet, id_event) {
      // Reset
      this.unavailable = false;

      // Se o tracker do mesmo id estiver aberto, apenas fecha;
      if (this.idBet == id_bet && this.idEvent == id_event) {
        this.closeTracker();
        this.disabledWidget = true;
        this.idBet = "";
        this.idEvent = "";
        return;
      }

      // Se já existe um tracker aberto, fecha o anterior
      if (this.idEvent != "") {
        this.closeTracker();
        this.unavailable = false;
        this.disabledWidget = true;
      }

      // https://statscore.atlassian.net/wiki/spaces/STW/pages/2917072899/Advanced
      var d = "STATSCOREWidgetsEmbederScript";
      if (!window.document.getElementById(d)) {
        (window.STATSCOREWidgets = {}),
          (window.STATSCOREWidgets.onLoadCallbacks = []),
          (window.STATSCOREWidgets.onLoad = function(d) {
            window.STATSCOREWidgets.onLoadCallbacks.push(d);
          });
        var n = window.document.createElement("script");
        (n.src = "https://wgt-s3-cdn.statscore.com/bundle/Embeder.js"),
          (n.async = !0),
          (n.id = d),
          n.addEventListener("error", function(d) {
            for (
              var n = 0;
              n < window.STATSCOREWidgets.onLoadCallbacks.length;
              n++
            )
              window.STATSCOREWidgets.onLoadCallbacks[n](d);
          }),
          window.document.body.appendChild(n);
      }

      // Hook up when library is loaded and ready to use.
      // You can use this method as many times as necessary - if library
      // is already loaded provided callback will fire immediately
      STATSCOREWidgets.onLoad((err) => {
        if (err) {
          switch (err.type) {
            case "NetworkError":
              this.disabledWidget = true;
              this.unavailable = true;
              break;
            case "BrowserNotSupported":
              this.disabledWidget = true;
              this.unavailable = true;
              break;
          }
          return;
        } else {
          this.disabledWidget = false;
        }

        // Widget will be appended to this HTMLElement.
        //
        // If you are using framework then follow its documentation
        // on how to get DOM Element from your component.
        // Vue.js https://vuejs.org/v2/api/#ref
        // React https://en.reactjs.org/docs/refs-and-the-dom.html
        // Angular https://angular.io/api/core/ElementRef
        const idElement = `widget-${id_bet}-${id_event}`;
        const element = document.getElementById(idElement);
        // Configuration that you should receive from STATSCORE
        const configurationId = "62abb4d3d4bbb801868d7950";
        // Input data for widget type you want to embded
        const inputData = {
          eventId: `m:${id_event}`,
          language: "br",
        };
        const options = {};
        widget = new window.STATSCOREWidgets.WidgetGroup(
          element,
          configurationId,
          inputData,
          options
        );

        // Armazenando o id do evento aberto e id da bet;
        this.idEvent = id_event;
        this.idBet = id_bet;

        widget.on("error", async () => {
          await widget.destroy();
          this.disabledWidget = true;
          this.unavailable = true;
        });
      });
    },
    async closeTracker() {
      await widget.destroy();
    },
  },
  filters: {
    dateFormat: function(datedb) {
      if (datedb == undefined) return;
      let date = new Date(datedb.replace(" ", "T")).toLocaleString();
      return date;
    },
  },
};
</script>
